import * as React from 'react';
import { ModalFullscreen } from '@cian/ui-kit';

import { INewbuildingMapPin } from '../../types/map';
import { NewbuildingsMap, TNewbuildingsMapPlatform } from '../NewbuildingsMap';
import * as styles from './styles.css';
import { CloseButton } from './parts';

export interface INewbuildingsMapModalProps {
  apiKey: string;
  pins: INewbuildingMapPin[];
  platform?: TNewbuildingsMapPlatform;
  onClose(): void;
  onPinClick(pin: INewbuildingMapPin): void;
}

export function NewbuildingsMapModal({
  apiKey,
  pins,
  platform,
  onClose,
  onPinClick,
}: INewbuildingsMapModalProps): React.JSX.Element {
  return (
    <ModalFullscreen escape open portal theme="white" onClose={onClose}>
      <div className={styles['container']} data-testid="newbuildings-map-modal">
        <NewbuildingsMap apiKey={apiKey} pins={pins} platform={platform} onPinClick={onPinClick} />
        <CloseButton onClose={onClose} />
      </div>
    </ModalFullscreen>
  );
}
